import empleo from '../landing/centroAyuda/Empleo1.jpeg';
import { Card } from 'react-bootstrap';
import { preguntasEmpresa, preguntasBDE, preguntasFrecuentes } from '../preguntas-cda';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

function ContentHelp() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get('help');
  const preguntasTotales = [...preguntasEmpresa, ...preguntasBDE, ...preguntasFrecuentes];
  const preguntasFiltradas = preguntasTotales.filter(pregunta => pregunta.link === query);

  return (
    <div>
      <div className="img" style={{ backgroundImage: `url(${empleo})`, height: '1rem' }}></div>
      <div className="container px-1">
        <Card className="pt-5" style={{ borderRadius: '1rem', top: '-300px', border: 'none' }}>
          {preguntasFiltradas.map(pregunta => (
            <div key={pregunta.id} className="">
              <Card.Title className='text-center'><strong>{pregunta.pregunta}</strong></Card.Title>
              <Card.Body className='m-5'>{pregunta.respuesta}</Card.Body>
            </div>
          ))}
        </Card>
      </div>
      <Footer />
    </div>
  );
}

export default ContentHelp;